try {
    const imageInterval = setInterval(imagesizes, 500);

    function imagesizes() {
        const images = document.querySelectorAll('img:not([height]');
        images.forEach(image => {
            const loadedImage = new Image();
            loadedImage.src = image.src;
            loadedImage.onload = function() {
                image.setAttribute('width', loadedImage.width);
                image.setAttribute('height', loadedImage.height);
            };
        });
    }
    setTimeout(() => {
        clearInterval(imageInterval);
    }, 3500);
} catch (error) {
    console.log('error');
}

try {
    const ratingselectInterval = setInterval(ratingselect, 500);

    function ratingselect() {
        const el = document.querySelector(".yotpo-dropdown-base");
        if (el) {
            let span = document.createElement("span");
            span.textContent = "Rating Select";
            span.setAttribute("id", "scoreDropdownLabel");
            span.classList.add("visually-hidden");
            el.prepend(span);
        } else {}
    }

    setTimeout(() => {
        clearInterval(ratingselectInterval);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const ugcroleInterval = setInterval(ugcrole, 500);

    function ugcrole() {
        const yotpo = document.querySelectorAll(".ugc-storefront-widgets-tabs-container__tab");
        if (yotpo) {
            yotpo.forEach((item) => {
                const innertext = item.innerText;
                item.setAttribute("role", "tab");
                item.setAttribute("aria-label", innertext);
            });
        } else {}
    }

    setTimeout(() => {
        clearInterval(ugcroleInterval);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const scoredropdownInterval = setInterval(scoredropdown, 500);

    function scoredropdown() {
        const yotposelect = document.querySelector("#scoreDropdownInput");
        if (yotposelect) {
            yotposelect.removeAttribute("aria-expanded");
        } else {}
    }

    setTimeout(() => {
        clearInterval(scoredropdownInterval);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const yotpolabelnterval = setInterval(arialabel, 500);

    function arialabel() {
        const yotpolabel = document.querySelector("button.yotpo-reviews-summary-button");
        if (yotpolabel) {
            yotpolabel.setAttribute('aria-label', 'Read summary by topics');
        } else {}
    }

    setTimeout(() => {
        clearInterval(yotpolabelnterval);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const yotpoLoyalty = setInterval(yloyalty, 500);

    function yloyalty() {
        const yotpoFieldset = document.querySelectorAll(".yotpo-tile-group");
        if (yotpoFieldset) {
            yotpoFieldset.forEach((label) => {
                const wrapper = label?.querySelector('.yotpo-campaign-switcher-wrapper');
                wrapper.removeAttribute('aria-label');
                const role = label?.querySelector('.yotpo-title-text');
                role.removeAttribute('role');
                const legend = document.createElement('legend');
                legend.textContent = role.innerText;
                legend.classList.add('visually-hidden');
                if (!label.querySelector('legend')) {
                    label.prepend(legend);
                }
            });
        }
        const yotpoBenefit = document.querySelectorAll(".yotpo-vip-tiers-grid-benefit-name");
        if (yotpoBenefit) {
            yotpoBenefit.forEach((benefit) => {
                const para = benefit?.querySelector('p');
                para.removeAttribute('title');
            });
        }
        const yotpoReward = document.querySelectorAll(".yotpo-redemption-option-reward");
        if (yotpoReward) {
            yotpoReward.forEach((reward) => {
                reward.removeAttribute('title');
            });
        }
        else {}
    }

    setTimeout(() => {
        clearInterval(yotpoLoyalty);
    }, 3500);
} catch (error) {
    console.log('error');
}

try {
    const sortbyInterval = setInterval(sortedby, 1000);

    function sortedby() {
        const sortbyselect = document.querySelectorAll(".ais-SortBy");
        let count = 1;
        if (sortbyselect) {
            sortbyselect.forEach((item) => {
                const label = document.createElement("label");
                label.className = "visually-hidden";
                label.setAttribute("for", `sortby${count}`);
                label.textContent = `Sorted by`;
                item.prepend(label);
                item.querySelector('select').setAttribute("id", `sortby${count}`);
                count++;
            });
        } else {}
        stop();
    }

    function stop() {
        clearInterval(sortbyInterval);
    }
} catch (error) {
    console.log('error');
}

try {
    const volumeInterval = setInterval(volume, 1000);

    function volume() {
        const rheostat = document.querySelectorAll(".rheostat-handle");
        let count = 1;
        if (rheostat) {
            rheostat.forEach((item) => {
                item.setAttribute("aria-label", `rheostat-handle${count}`);
                count++;
            });
        } else {}
        stop();
    }

    function stop() {
        clearInterval(volumeInterval);
    }
} catch (error) {
    console.log('error');
}

try {
    const yotpoBottomLine = setInterval(ylabel, 500);

    function ylabel() {
        const yotpoBtn = document.querySelectorAll('button.yotpo-sr-bottom-line-button');
        yotpoBtn.forEach(element => {
            if (element) {
                const innertext = element.innerText.trim();
                element.setAttribute('aria-label', innertext);
            } else {}
        });
    }

    setTimeout(() => {
        clearInterval(yotpoBottomLine);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const yotpoReviewerTitle = setInterval(ytitle, 500);

    function ytitle() {
        const reviewer_names = document.querySelectorAll('.yotpo-reviewer-name');
        if (reviewer_names) {
            reviewer_names.forEach(reviewer => {
                reviewer.removeAttribute('title');
            });
        } else {}
    }

    setTimeout(() => {
        clearInterval(yotpoReviewerTitle);
    }, 3000);
} catch (error) {
    console.log('error');
}

try {
    const algolialnterval = setInterval(ariaLabelledby, 500);

    function ariaLabelledby() {
        const autoComplete = document.querySelectorAll('.aa-Autocomplete[role="combobox"]');
        const width = window.innerWidth;
        if (autoComplete.length > 0) {
            console.log('Removing aria-labelledby from autocomplete');
            autoComplete.forEach(label => {
                if (width < 768) {
                    label.removeAttribute('aria-labelledby');
                }
            });
        }
    }
    ariaLabelledby();

    setTimeout(() => {
        clearInterval(algolialnterval);
    }, 3000);
} catch (error) {
    console.log('error');
}